module.exports = __webpack_public_path__ + "static/media/august-pdf.5b1ddc16.jpg";